module.exports = __webpack_public_path__ + "static/policies-list-2-b51c9e1f77702bd948f31f210c75929d.png";